module.exports = __webpack_public_path__ + "3fbaf869bfb2f498874c1d982d210064.svg";